import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { CartProvider } from "./contexts/CartContext";
import HomePage from "./components/HomePage";
import AdvanceOrdersPage from "./components/AdvanceOrdersPage";
import AdminDashboard from "./components/AdminDashboard";
import LoginPage from "./components/LoginPage";
import RegistrationPage from "./components/RegistrationPage";
import ForgotPasswordPage from "./components/ForgotPasswordPage";
import OrderHistoryPage from "./components/OrderHistoryPage";

// Login is OPTIONAL - users can browse without logging in
const SKIP_AUTH = false;  // Changed to false to enable real authentication

function App() {
  const [user, setUser] = useState(null);
  const [authMode, setAuthMode] = useState('login'); // 'login' or 'register'
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check if user is already logged in
    const token = localStorage.getItem('auth_token');
    const userData = localStorage.getItem('user_data');
    
    if (token && userData) {
      try {
        setUser(JSON.parse(userData));
      } catch (error) {
        console.error('Error parsing user data:', error);
        localStorage.removeItem('auth_token');
        localStorage.removeItem('user_data');
      }
    }
    
    setIsLoading(false);
  }, []);

  const handleLoginSuccess = (loginData) => {
    setUser(loginData.user);
  };

  const handleRegistrationSuccess = (userData) => {
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('user_data');
    setUser(null);
  };

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
        <div className="text-center">
          <img 
            src="https://customer-assets.emergentagent.com/job_meds-storage/artifacts/16xboc6r_WhatsApp%20Image%202025-10-14%20at%2021.25.24_e01b08d0.jpg"
            alt="Alberta Pharmacy Supply Logo"
            className="w-20 h-20 mx-auto mb-4"
          />
          <p className="text-slate-600">Loading...</p>
        </div>
      </div>
    );
  }

  // Login is OPTIONAL - users can browse without being logged in
  return (
    <div className="App">
      <CartProvider user={user}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage user={user} onLogout={handleLogout} />} />
            <Route path="/advance-orders" element={<AdvanceOrdersPage user={user} onLogout={handleLogout} />} />
            <Route path="/admin" element={
              user && (user.role === 'admin' || user.email === 'aprxsupply@gmail.com') 
                ? <AdminDashboard user={user} /> 
                : <Navigate to="/login" replace />
            } />
            <Route path="/orders" element={
              user ? <OrderHistoryPage user={user} /> : <Navigate to="/login" replace />
            } />
            <Route path="/login" element={<LoginPage onLoginSuccess={handleLoginSuccess} />} />
            <Route path="/register" element={<RegistrationPage onRegistrationSuccess={handleRegistrationSuccess} />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </CartProvider>
    </div>
  );
}

export default App;